import React, { useEffect, useState } from 'react';
import { Input, Dropdown, Button } from '../utils';
import { usePlantContext } from "../../context/plantContext";
import { useDevices } from '../../services/hooks';
import { buttonClasses } from "../utils/theme";
import { valid_email, valid_mobile } from '../../services/validation';
import { useUpdateDeviceAlertMutation } from '../../api/deviceSlice';
import { toastMessage } from '../utils';

const defaultAlert = {
            "id" : "",
            "displayName" : "",
            "alertConfig" : {
                "BoomOpen" : {alertThreshold: 0,
                cooldownPeriod: 0,
                notifyEmails: [],
                notifyMobiles: [],}
            }
        }

export default function AlertConfig() {
    const { plantId, plantOptions, loading, updatePlantId, isCheckpointForm} = usePlantContext();
    const { devices, count, isLoading, getDevices } = useDevices({pagesize: 1000,page_no: 1, plantIds: plantId, deviceType: "rfid"});
    const [handleUpdateDevice, { isLoading: isUpdating }] = useUpdateDeviceAlertMutation();
    // const [JbOpen, setJbOpen] = useState({ 
    //   alertThreshold: 0,
    //   cooldownPeriod: 0,
    //   notifyEmails: [],
    //   notifyMobiles: [],
    // });
    const [deviceList, setDeviceList] = useState([]);
    const selectedDefaultPlant = plantOptions.find((opt) => opt.value === plantId) || plantOptions[0] || null;
    const [selectedPlant, setSelectedPlant] = useState(selectedDefaultPlant);
    const [error, setError] = useState({});
    const handleAlertConfigChange = (value, name, id) => {
        if(true){
            setDeviceList((old) => old.map(item => 
                item.id === id ? {
                    ...item,
                    alertConfig: {
                        ...item.alertConfig,
                        BoomOpen: {
                            ...item.alertConfig.BoomOpen,
                            [name]: Array.isArray(value) ? value.map((_) => _.value) : value
                        }
                    }
                } : item
            ));
        }
    };
    const handleFormSubmit = async (formData) => {
        const validationErrors = validateFormData(formData);
        if (Object.keys(validationErrors).length > 0) {
            setError(validationErrors)
            return;
        }
        setError({})
        console.log('formdata', formData);
        const {data: { error, message }} = await handleUpdateDevice({...formData, plantId})
        // console.log({error, message})
        if (error) {
            toastMessage(false, message);
        } else {
            toastMessage(true, message);
            // navigate("/devices", { state: { filterData: filterData || "" } });
        }
    };

    useEffect(() => {
        if (selectedPlant?.value) { // Fixed: check if selectedPlant exists
            getDevices({ pagesize: 1000, page_no: 1, plantIds: selectedPlant.value, deviceType: "rfid" });
        }
    }, [selectedPlant]);

    useEffect(()=>{
        if(devices?.length > 0){
            const deviceList = devices.filter((el) => el.deviceSubType ==="customReader" && el.hasOwnProperty('alertConfig') && Object.keys(el.alertConfig?.BoomOpen).length > 0)?.map((el) => ({id : el._id, "displayName" : el.displayName, "alertConfig" : el.alertConfig})) || [];
            console.log('deviceList', deviceList)
            setDeviceList(deviceList)
        }else{
            setDeviceList([])
        }
    }, [devices])
    return (
        <div style={{ padding: "10px" , paddingTop: '20px' }}>
            <div style={{ minWidth: "200px" }}>
                {plantOptions && plantOptions.length > 1 ? <Dropdown
                label="Select Warehouse"
                options={plantOptions || []}
                value={selectedPlant}
                onChange={(value)=> setSelectedPlant(value) }
                // disabled={loading || !plantOptions || plantOptions.length === 0}
                // disableClearable={true}
                /> : null}
            </div>
            {deviceList.length > 0 && deviceList.map((device, index)=> (
                <div key={device.id || index}>
                    <h6 style={{ marginTop : '10px'}}>Boom Open Alert :</h6>
                    <div style={{ display: "flex", gap: "0.5rem", width: "100%" }}>
                        <div style={{ display: "flex", gap: "1rem",flexWrap: "wrap"}} className="p-3 border boder-rad-10p ">
                        <Input
                            label="Device Name"
                            value={device.displayName}
                            error={error.id}
                            readOnly
                        />
                        <Input
                            type="number"
                            id={`alertThreshold-${device.id}`}
                            name="alertThreshold"
                            value={device.alertConfig.BoomOpen.alertThreshold || 0}
                            label="Alert Threshold (sec)"
                            onChange={(e) => handleAlertConfigChange(e.target.value, e.target.name, device.id)}
                            required={true}
                            error={error.BoomOpen?.alertThreshold || error.BoomOpenAlertThreshold}
                            sx={{ width: '160px' }}
                        />
                        <Input
                            type="number"
                            id={`cooldownPeriod-${device.id}`}
                            name="cooldownPeriod"
                            value={device.alertConfig.BoomOpen.cooldownPeriod || 0}
                            label="Cooldown Period (sec)"
                            onChange={(e) => handleAlertConfigChange(e.target.value, e.target.name, device.id)}
                            required={true}
                            error={error.BoomOpen?.cooldownPeriod || error.BoomOpenCooldownPeriod}
                            sx={{ width: '160px' }}
                        />
                        <div style={{ minWidth: "245px" }}>
                            <Dropdown
                                id={`notifyEmails-${device.id}`}
                                name="notifyEmails"
                                label="Notify Emails"
                                onChange={(option, name) => handleAlertConfigChange(option, name, device.id)}
                                options={device.alertConfig.BoomOpen.notifyEmails?.length > 0 ? device.alertConfig.BoomOpen.notifyEmails.map((el) => ({ label: el, value: el })) : []}
                                value={device.alertConfig.BoomOpen.notifyEmails?.length > 0 ? device.alertConfig.BoomOpen.notifyEmails.map((el) => ({ label: el, value: el })) : []}
                                enableCustomValue={true}
                                validateValue={(value) => valid_email(value)}
                                error={error.BoomOpen?.notifyEmails || error.BoomOpenNotifyEmails}
                                multiple={true}
                                required
                            />
                        </div>
                        <div style={{ minWidth: "245px" }}>
                            <Dropdown
                                id={`notifyMobiles-${device.id}`}
                                name="notifyMobiles"
                                label="Notify Mobiles"
                                onChange={(option, name) => handleAlertConfigChange(option, name, device.id)}
                                options={device.alertConfig.BoomOpen.notifyMobiles?.length > 0 ? device.alertConfig.BoomOpen.notifyMobiles.map((el) => ({ label: el, value: el })) : []}
                                value={device.alertConfig.BoomOpen.notifyMobiles?.length > 0 ? device.alertConfig.BoomOpen.notifyMobiles.map((el) => ({ label: el, value: el })) : []}
                                enableCustomValue={true}
                                validateValue={(value) => valid_mobile(value)}
                                error={error.BoomOpen?.notifyMobiles || error.BoomOpenNotifyMobiles}
                                multiple={true}
                                required
                            />
                        </div>
                        {<Button text={"Update"} style={{ ...buttonClasses.lynkitOrangeFill, width: "80px", height : '38px' }} onClick={() => handleFormSubmit(device)} />}
                        </div>
                    </div>
                </div>
            ))}
        </div>
        
    );
}


const validateFormData = (formData) => {
    const errors = {};

    // Validate ID
    if (!formData.id || formData.id.trim() === '') {
        errors.id = 'Device ID is required';
    }

    // Validate displayName
    if (!formData.displayName || formData.displayName.trim() === '') {
        errors.displayName = 'Device name is required';
    }

    // Validate alertConfig exists
    if (!formData.alertConfig || typeof formData.alertConfig !== 'object') {
        errors.alertConfig = 'Alert configuration is required';
        return errors; // Return early if no alertConfig
    }

    // Validate each alert type (BoomOpen, JbOpen, etc.)
    Object.entries(formData.alertConfig).forEach(([alertType, alertConfig]) => {
        const alertErrors = {};
        // console.log('alertConfig', alertConfig)
        // Validate alertThreshold
        if (!alertConfig.alertThreshold || alertConfig.alertThreshold == 0) {
            alertErrors.alertThreshold = `Alert threshold is required`;
        } else if (isNaN(alertConfig.alertThreshold) || Number(alertConfig.alertThreshold) < 0) {
            alertErrors.alertThreshold = `Alert threshold must be a positive number`;
        }

        // Validate cooldownPeriod
        if (!alertConfig.cooldownPeriod || alertConfig.cooldownPeriod == 0) {
            alertErrors.cooldownPeriod = `Cooldown period is required`;
        } else if (isNaN(alertConfig.cooldownPeriod) || Number(alertConfig.cooldownPeriod) < 0) {
            alertErrors.cooldownPeriod = `Cooldown period must be a positive number`;
        }

        // Validate notifyEmails
        // if (!alertConfig.notifyEmails || !Array.isArray(alertConfig.notifyEmails)) {
        //     alertErrors.notifyEmails = `Notify emails must be an array`;
        // } else {
        //     alertConfig.notifyEmails.forEach((email, index) => {
        //         if (!valid_email(email)) {
        //             if (!alertErrors.notifyEmails) alertErrors.notifyEmails = [];
        //             alertErrors.notifyEmails[index] = 'Invalid email format';
        //         }
        //     });
        //     // If all emails are valid but array is empty
        //     if (alertConfig.notifyEmails.length === 0) {
        //         alertErrors.notifyEmails = 'At least one email is required';
        //     }
        // }

        // Validate notifyMobiles
        // if (!alertConfig.notifyMobiles || !Array.isArray(alertConfig.notifyMobiles)) {
        //     alertErrors.notifyMobiles = `Notify mobiles must be an array`;
        // } else {
        //     alertConfig.notifyMobiles.forEach((mobile, index) => {
        //         if (!valid_mobile(mobile)) {
        //             if (!alertErrors.notifyMobiles) alertErrors.notifyMobiles = [];
        //             alertErrors.notifyMobiles[index] = 'Invalid mobile number format';
        //         }
        //     });
        //     // If all mobiles are valid but array is empty
        //     if (alertConfig.notifyMobiles.length === 0) {
        //         alertErrors.notifyMobiles = 'At least one mobile number is required';
        //     }
        // }

        // If there are errors for this alert type, add them to main errors
        if (Object.keys(alertErrors).length > 0) {
            errors[alertType] = alertErrors;
        }
    });

    return errors;
};
